import { ITemplateEditor } from './types';

export const initialState: ITemplateEditor = {
  templates: [],
  selectedTemplate: null,
  mergeTokenList: {},
  miscellaneous: {},
};
